import { yupResolver } from "@hookform/resolvers/yup";
import { useSnackbar } from "notistack";
import { useForm } from "react-hook-form";
import useErrors from "src/hooks/useErrors";
import { useFormContext } from "react-hook-form";
import fetchUser from "src/utils/fetchUser";
import { mixed, number, object, string } from "yup";

export const defaultValues = {
  wallet: "ewallet",
  amount: "",
  username: "",
};

const schema = object().shape({
  wallet: mixed()
    .oneOf(["ewallet", "deposit_wallet"], "Please choose a wallet")
    .required("Please choose a from wallet"),

  amount: number()
    .min(1, "The minimum amount should be 1")
    .typeError("Please enter a valid amount")
    .required("Please choose an amount"),
  username: string().required("Please enter a Account ID"),
});

const useFundForm = (refetch, fetchData, setOpenQrDialog) => {
  const { enqueueSnackbar } = useSnackbar();
  // const { setError } = useFormContext();
  const methods = useForm({
    defaultValues: defaultValues,
    resolver: yupResolver(schema),
  });

  const { setError } = methods;
  const onSubmit = async (inputData) => {
    const reqData = new FormData();
    const { name, ...rest } = inputData;
    Object.entries(rest).forEach(([key, value]) => reqData.append(key, value));
    try {
      const { message, status } = await (
        await fetchUser.post("fund-transfer-verification", reqData)
      ).data;

      if (status) {
        enqueueSnackbar(message);
        setOpenQrDialog(true);
        // methods.reset(defaultValues);
        refetch();
        fetchData();
      }
    } catch (err) {
      if (Boolean(err.errors.referral)) {
        enqueueSnackbar(err.errors.referral, { variant: "error" });
      }
      Object.entries(err.errors).forEach(([k, v]) => {
        setError(k, { message: v?.flat()?.find(Boolean) || "" });
      });
      // setError("amount", { message: err.message });
    }
  };

  return { methods, onSubmit: methods.handleSubmit(onSubmit) };
};

export default useFundForm;
